import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Grid2,
} from "@mui/material";
import { Genders, Prefixes } from "../Utility/Constants";
import GenericTextField from "../common/GenericTextField";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import GenericDatePicker from "../common/GenericDatePicker";
import { calculateAgeOnlyYear } from "../Utility/Utility";

const NewPatientDialog = ({ open, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    prefix: "",
    firstName: "",
    lastName: "",
    gender: "",
    dateOfBirth: "",
    age: "",
    phone: "",
  });
  const handleChange = (e) => {
  const { name, value } = e.target;

    if (name === "dateOfBirth") {
      setFormData((prev) => ({
        ...prev,
        ["dateOfBirth"]: value,
        ["age"]: calculateAgeOnlyYear(value),
      }));
      return;
    }

    if (name === "age") {
      const age = parseInt(value, 10);
      if (!isNaN(age)) {
        const today = new Date();
        const birthDate = new Date(
          today.getFullYear() - age,
          today.getMonth(),
          today.getDate(),
        );
        const dobStr = birthDate.toISOString().split("T")[0];

      return setFormData((prev) => ({
        ...prev,
        age: value,
        dateOfBirth: dobStr,
      }));
    }
  }

  if (name === "phone") {
    if (value.length > 10) return;
  }
  
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "age") {
  //     const age = parseInt(value, 10);
  //     if (!isNaN(age)) {
  //       const today = new Date();
  //       const birthDate = new Date(
  //         today.getFullYear() - age,
  //         today.getMonth(),
  //         today.getDate()
  //       );
  //       const dobStr = birthDate.toISOString().split("T")[0];

  //       setFormData((prev) => ({
  //         ...prev,
  //         age: value,
  //         dateOfBirth: dobStr,
  //       }));
  //     } else {
  //       setFormData({ ...formData, [name]: value });
  //     }
  //   } else if (name === "phone") {
  //     // Prevent input beyond 10 digits
  //     if (value.length > 10) return;
  //     setFormData({ ...formData, [name]: value });
  //   } else {
  //     setFormData({ ...formData, [name]: value });
  //   }
  // };

  const handleSave = async () => {
    await onSave(formData);
    setFormData({
      prefix: "",
      firstName: "",
      lastName: "",
      gender: "",
      dateOfBirth: "",
      age: "",
      phone: "",
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add New Patient</DialogTitle>
      <DialogContent dividers>
        <GenericTextField
          select
          label="Prefix"
          name="prefix"
          value={formData.prefix}
          onChange={handleChange}
          fullWidth
        >
          {Prefixes.map((prefix) => (
            <MenuItem key={prefix} value={prefix}>
              {prefix}
            </MenuItem>
          ))}
        </GenericTextField>
        <GenericTextField
          label="First Name"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          fullWidth
        />
        <GenericTextField
          label="Last Name"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          fullWidth
        />
        <GenericTextField
          select
          label="Gender"
          name="gender"
          value={formData.gender}
          onChange={handleChange}
          fullWidth
        >
          {Genders.map((gender) => (
            <MenuItem key={gender} value={gender}>
              {gender}
            </MenuItem>
          ))}
        </GenericTextField>

        {/* DOB and Age in Two Columns */}
      <Grid2 container spacing={2}>
  <Grid2 size={6}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <GenericDatePicker
        label="Date of Birth"
        value={formData.dateOfBirth ? dayjs(formData.dateOfBirth) : null}
        onChange={(value) => {
          setFormData((prev) => ({
            ...prev,
            dateOfBirth: value ? value.format("YYYY-MM-DD") : "",
            age: value ? calculateAgeOnlyYear(value.format("YYYY-MM-DD")) : "",
          }));
        }}
        maxDate={dayjs()}
        returnDayjsObject={true}
        required={true}
        error={false}
        displayFormat="DD-MMM-YYYY"
      />
    </LocalizationProvider>
  </Grid2>
  <Grid2 size={6}>
    <GenericTextField
      label="Enter Age"
      name="age"
      type="number"
      value={formData.age}
      onChange={handleChange}
      fullWidth
      slotProps={{
        inputLabel: { shrink: true },
      }}
    />
  </Grid2>
</Grid2>

        <GenericTextField
          label="Mobile Number"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          fullWidth
          type="number"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          disabled={
            !formData.prefix ||
            !formData.firstName ||
            !formData.lastName ||
            !formData.gender ||
            !formData.dateOfBirth ||
            !formData.phone ||
            !formData.age
          }
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewPatientDialog;
